import React from 'react';

class Kskapi extends React.Component {
  render() {
    let hostInfo = this.props.hostInfo;

    return (
      <div
        className='pure-g pure-p pure-u-1'
        style={{ position: 'relative', backgroundColor: 'white', paddingTop: 30, marginBottom: 10 }}
      >
        <div style={{ position: 'absolute', top: 0, left: 0 }}>
          <div className='box-info'>kskapi/payapi</div>
        </div>

        <div className='info-card pure-u-6-24'>
          <span>kskapi Mode:</span>
          {hostInfo.kskapiMode}
        </div>
        <div className='info-card pure-u-6-24'>
          <span>payapi CCMode:</span>
          {hostInfo.payapiCCMode}
        </div>
        <div className='info-card pure-u-12-24'>
          <span>payapi Processors Status:</span>
          {hostInfo.payapiProcessorsStatus}
        </div>
      </div>
    );
  }
}

export default Kskapi;



// WEBPACK FOOTER //
// ./src/components/Kskapi.js